import db from 'utils/localstorage'

export default {
    namespaced: true,
    state: {
        userName: db.get('USER_NAME'),
        verificationCode: db.get('verificationCode'),
        tenantName: db.get('TenantName')
    },
    mutations: {
        setUserName(state, val) {
            db.save('USER_NAME', val)
            state.userName = val
        },
        setVerificationCode(state, val) {
            db.save('verificationCode', val)
            state.verificationCode = val
        },
        setTenantName(state, val) {
            db.save('TenantName', val)
            state.tenantName = val
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/findpassword.js